function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}var SearchProviderInterface = /*#__PURE__*/function () {
  function SearchProviderInterface(viewer) {_classCallCheck(this, SearchProviderInterface);
    this.viewer = viewer;
  }

  /**
     * Performs search in search providers
     * @param {string} userInput - search query input from user
     * @returns {Promise} Promise with array of dbIds for each model.
     */_createClass(SearchProviderInterface, [{ key: "search", value: function search(
    userInput) {
      return new Promise(function (resolve, reject) {
      });
    }

    /**
       * @returns {string} Name of Search Provider
       */ }, { key: "getProviderId", value: function getProviderId()
    {
      return 'Search Provider Id';
    } }]);return SearchProviderInterface;}();export { SearchProviderInterface as default };